module.exports = require("react-sizeme");


//////////////////
// WEBPACK FOOTER
// external "react-sizeme"
// module id = 135
// module chunks = 0